export default "__VITE_ASSET__DYydF241__"